<template>
  <v-container fluid class="main-container">
    <v-row class="my-0">
      <v-col cols="12" sm="6" class="information-trial my-0 py-0">
        <v-fade-transition>
          <div v-if="questionAnsweredValues === totalValues
            && questionAnsweredValues > 0">
            <div id="congratulationsModal" class="modal">
              <div class="modal-right-side">
                <v-row>
                  <v-col class="mb-0 pb-0" cols="12" md="3" justify="left">
                    <v-img class="modal-logo mb-0 pb-0" :src="require('../assets/images/patient_up_logo.png')"
                      :contain="true" />
                  </v-col>
                </v-row>
                <v-row>
                  <hr class="gradient-line" />
                </v-row>
                <v-row>
                  <h3 class="modal-trial-title">
                    {{ $t('positive-result-screen.congratulations') }}
                  </h3>
                </v-row>
                <v-row>
                  <div class="modal-trial-text">
                    <p v-html="$t('positive-result-screen.msg')" />
                  </div>
                  <v-row class="mb-5" justify="center">
                    <v-btn class="modal-trial-button" x-large @click="trialNextStep()">
                      {{ $t('positive-result-screen.button-next') }}
                    </v-btn>
                  </v-row>
                </v-row>
              </div>
            </div>
          </div>
          <div v-if="questionAnsweredValues < totalValues">
            <div id="negativeModal" class="modal">
              <div class="modal-trial-negative-content">
                <v-row>
                  <v-col class="mb-0 pb-0" cols="12" md="3" justify="left">
                    <v-img class="modal-logo mb-0 pb-0" :src="require('../assets/images/patient_up_logo.png')"
                      :contain="true" />
                  </v-col>
                </v-row>
                <v-row>
                  <hr class="gradient-line" />
                </v-row>
                <v-row>
                  <h3 class="modal-trial-negative-title">
                    {{ $t('negative-result-screen.sorry-msg') }}
                  </h3>
                </v-row>
                <v-row>
                  <div class="modal-trial-negative-text">
                    <p v-html="$t('negative-result-screen.msg')" />
                  </div>
                </v-row>
                <v-row>
                  <div class="modal-checkbox-negative">
                    <v-checkbox class="accept-checkbox" v-model="acceptConsent" @change="toggleCheckbox('accept')">
                      <template v-slot:label>
                        <span v-html="$t('negative-result-screen.accept')" />
                      </template>
                    </v-checkbox>
                    <v-checkbox class="decline-checkbox" v-model="declineConsent" @change="toggleCheckbox('decline')">
                      <template v-slot:label>
                        <span v-html="$t('negative-result-screen.decline')" />
                      </template>
                    </v-checkbox>
                  </div>
                </v-row>
                <v-row>
                  <div class="modal-trial-negative-thx">
                    <p> {{ $t('negative-result-screen.inconvenience-msg') }} </p>
                    <p> {{ $t('negative-result-screen.thx-msg') }} </p>
                  </div>
                </v-row>
                <v-row class="mb-5" justify="center">
                  <v-btn class="modal-trial-negative-button" x-large 
                    :class="checkNegativeButton
                    ? 'button-enabled'
                    : 'button-disabled'"
                    :disabled="!checkNegativeButton" 
                    @click="endStep()">
                    {{ $t('negative-result-screen.button-next') }}
                  </v-btn>
                </v-row>
              </div>
            </div>
          </div>
        </v-fade-transition>
      </v-col>
    </v-row>
    <v-row class="main-screen">
      <v-col cols="12" md="6" class="sermes-image-content" ref="imageCol">
        <template v-if="!isMobile">
          <v-responsive :aspect-ratio="aspectRatio" class="sermes-image">
            <v-img :src="imageSrc" class="responsive-image" contain alt="Imagen" />
          </v-responsive>
        </template>
        <template v-else>
          <v-img :src="imageSrc" class="responsive-image mobile-image" contain alt="Imagen" />
        </template>
      </v-col>
      <v-col cols="12" md="6" class="questionary-content">
        <v-row>
          <v-col cols="12" sm="6" class="language-icons">
            <locale-switcher />
          </v-col>
        </v-row>
        <v-row class="right-side">
          <v-col cols="12" class="pb-0 mx-0 px-0 my-0 py-0">
            <v-card id="trial-form-card" class="form-card questions-scrollable">
              <v-card-title primary-title class="justify-left pt-0">
                <h3 class="step-title">
                  <span id="trial-form-title">
                    {{ $t('questionary-screen.title') }}
                  </span>
                </h3>
              </v-card-title>
              <v-card-text class="questions-content">
                <v-form id="trial-form" ref="form" v-model="valid" lazy-validation>
                  <div v-for="(question, index) in questions" :key="question.form_id">
                    <v-row class="mb-1">
                      <v-col v-if="!isYesNoQuestion(question.options) && question.multiple == false" cols="12">
                        <label :for="'select-' + index">{{ question.question }}</label>
                        <v-select class="trial-form-input-select ml-0 pl-0 mb-0 pb-0 pt-1 mt-1"
                          :error="selectErrors[index]" :items="question.options"
                          :label="$t('questionary-screen.select')" item-text="option" item-value="value" hint=""
                          return-object required @change="(selection) => { selectionChanged(selection, index); }" />
                      </v-col>
                      <v-col v-else-if="question.multiple == true" cols="12">
                        <div class="question-label">
                          {{ question.question }}
                        </div>
                        <div>
                          <v-select class="trial-form-input-select ml-0 pl-0 mb-0 pb-0 pt-1 mt-1"
                            :items="question.options" :label="$t('questionary-screen.multiple-select')"
                            item-text="option" item-value="value" v-model="multipleSelectedAnswers[index]"
                            @change="(selection) => { multipleSelectionChanged(selection, index); }" multiple chips
                            clearable />
                        </div>
                      </v-col>
                      <v-col v-else cols="12">
                        <div class="question-label">
                          {{ question.question }}
                        </div>
                        <v-radio-group
                          @change="(selection) => { handleRadioChange(selection, question.options, index); }" row
                          :class="radioErrors[index] ? 'invalid-radio' : ''">
                          <v-radio class="mr-4" v-for="(option, i) in question.options" :key="i" :label="option.option"
                            :value="option.value" />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>
              </v-card-text>
              <v-card-actions v-if="questions.length" class="trial-buttons justify-center">
                <v-btn id="trial-form-previous-button" x-large
                  :class="disablePrevButton ? 'trial-button button-disabled' : 'trial-button button-enabled'"
                  @click="previousStep()">
                  {{ $t('questionary-screen.button-prev') }}
                </v-btn>
                <v-btn id="trial-form-next-button" x-large
                  :class="isNextBtnDisabled ? 'trial-button button-disabled' : 'trial-button button-enabled'"
                  @click="nextStep()">
                  {{ $t('questionary-screen.button-next') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, isSupported } from 'firebase/analytics';
import { trialServices } from '../services/trialService';
import LocaleSwitcher from './LocaleSwitcher.vue';
import getFirebaseConfig from '../utils/firebaseConfig';
import patientUpLogo from '../assets/images/patient_up_logo.png';
import mujer01 from '../assets/images/muneca.png';

export default {
  name: 'PatologyForm',
  components: {
    LocaleSwitcher,
  },
  data() {
    return {
      trial: '',
      icons: ['mdi-information ', 'mdi-account', 'mdi-medical-bag', 'mdi-doctor'],
      step: 3,
      centers: [],
      questions: [],
      questionAnsweredValues: 0,
      totalValues: 0,
      selectedAnswers: [],
      multipleSelectedAnswers: [],
      valid: false,
      isFormInvalid: false,
      selectErrors: [],
      radioErrors: [],
      acceptConsent: false,
      declineConsent: false,
      dataConsent: false,
      currentLanguage: null,
      aspectRatio: 0.796,
      analyticsInitialized: false,
    };
  },
  computed: {
    ...mapGetters(['cookiesAccepted']),
    isNextBtnDisabled() {
      this.selectedAnswers.some((answer) => answer == null);
      return this.selectedAnswers === undefined ? false : this.selectedAnswers.some((answer) => answer == null);
    },
    checkNegativeButton() {
      return this.acceptConsent === true || this.declineConsent === true;
    },
    disablePrevButton() {
      /* eslint-disable-next-line */
      return this.step !== 3 ? true : false;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    imageSrc() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
        return patientUpLogo;
      }
      return mujer01;
    },
  },
  created() {
    this.questionAnsweredValues = 0;
    this.totalValues = 0;
    this.trial = this.$store.state.trialId;
    this.currentLanguage = this.$store.state.selectedLanguage.toUpperCase();
    if (this.$store.state.cookiesAccepted === true) {
      this.initializeAnalytics();
    }
    trialServices.getTrialInformation(this.trial)
      .then((response) => {
        this.questions = response.form.map((question) => ({
          ...question,
          options: question.options.map((option, optionIdx) => ({
            ...option,
            optionValue: option.value,
            value: optionIdx,
          })),
        }));
        this.selectErrors = new Array(this.questions.length).fill(false);
        this.selectedAnswers = new Array(this.questions.length).fill(null);
        this.multipleSelectedAnswers = new Array(this.questions.length).fill([]);
        this.radioErrors = new Array(this.questions.length).fill(false);
        this.centers = response.center;
      })
      .catch((error) => {
        console.log(error);
      });
    this.addEvent('page_view', 'Trial Form view');
  },
  watch: {
    selectedLanguage(newVal) {
      this.currentLanguage = newVal;
    },
    selectedAnswers: {
      handler(newVal) {
        newVal.forEach((answer, index) => {
          if (answer !== null && this.selectErrors[index]) {
            this.$set(this.selectErrors, index, false);
          }
        });
      },
      deep: true,
    },
    acceptConsent(newVal) {
      if (newVal) {
        this.acceptConsent = true;
        this.declineConsent = false;
      }
    },
    declineConsent(newVal) {
      if (newVal) {
        this.acceptConsent = false;
        this.declineConsent = true;
      }
    },
  },
  methods: {
    handleCheckboxChange(selectedValues, index) {
      this.$set(this.selectedAnswers, index, selectedValues);
      this.$set(this.selectErrors, index, selectedValues.length === 0);
    },
    toggleCheckbox(selection) {
      if (selection === 'accept') {
        this.dataConsent = true;
      } else if (selection === 'decline') {
        this.dataConsent = false;
      }
    },
    async addEvent(eventName, passName) {
      if (!this.analyticsInitialized) {
        await this.initializeAnalytics(); 
      }
      
      if (this.$store.state.cookiesAccepted === true) {
        logEvent(this.analytics, eventName, { name: eventName, arguments: passName });

        // Google Analytics
        if (typeof gtag === 'function') {
          // eslint-disable-next-line no-undef
          gtag('event', eventName, {
            event_category: 'Patient Trial',
            event_label: passName,
          });
        }
      }
    },
    handleRadioChange(selection, options, index) {
      const selectedOption = options.find((option) => option.value === selection);
      this.$set(this.selectedAnswers, index, selectedOption);
      this.$set(this.radioErrors, index, false);
    },
    previousStep() {
      this.step -= 1;
      this.$emit('updateTrialStep', { step: this.step });
      this.addEvent('step3_prev_buton', 'Step3 Prev Button');
    },
    checkQuestionAnswered() {
      if (this.selectedAnswers) {
        this.totalValues = this.selectedAnswers.length;
        this.questionAnsweredValues = 0;
        this.selectedAnswers.forEach((question) => {
          this.questionAnsweredValues += parseInt(question.optionValue, 10);
        });
        // console.log(JSON.stringify(this.questionAnsweredValues));
      }
    },
    nextStep() {
      let allQuestionsAnswered = true;
      this.questions.forEach((_, index) => {
        if (this.selectedAnswers[index] === undefined || this.selectedAnswers[index] === null) {
          allQuestionsAnswered = false;
          this.$set(this.selectErrors, index, true);
          this.$set(this.radioErrors, index, true);
        }
      });

      if (!allQuestionsAnswered) {
        return;
      }

      this.isFormInvalid = false;
      const questionsText = this.questions.map((question) => question.question);

      const transformedAnswers = this.selectedAnswers.map((item) => {
        if (Array.isArray(item)) {
          const combinedOption = item.map((subItem) => subItem.option);
          const { value, optionValue } = item[item.length - 1];
          return {
            option: combinedOption,
            value,
            optionValue,
          };
        }
        return item;
      });
      this.selectedAnswers = transformedAnswers;
      this.step += 1;
      this.$emit('updateTrialStep', {
        step: this.step,
        hospitals: this.centers,
        questions: questionsText,
        selectedAnswers: transformedAnswers,
      });
      this.checkQuestionAnswered();

      // Store data always as not accepted if user not pass
      if (this.questionAnsweredValues !== this.totalValues && this.questionAnsweredValues > 0) {
        this.$emit('updateSaveProvisionalNoAcceptedData', {});
      } else {
        this.$emit('updateSaveProvisionalAcceptedData', {});
      }
      this.addEvent('step3_next_buton', 'Step3 Next Button');
    },
    trialNextStep() {
      this.step += 1;
      this.$emit('trialNextStep', {
        step: this.step,
      });
    },
    checkValidForm() {
      return (this.selectedAnswers.length === this.questions.length
        && this.selectedAnswers.length > 0
        && !this.selectedAnswers.includes(null)
        && !this.selectedAnswers.includes(undefined));
    },
    selectionChanged(selection, index) {
      this.$set(this.selectedAnswers, index, selection);
    },
    multipleSelectionChanged(selection, index) {
      const questionOptions = this.questions[index].options;
      const noneOption = questionOptions.find((option) => this.currentLanguage === 'ES'
        && option.option.includes('ninguna') && option.option.includes('anteriores'));

      if (noneOption) {
        const noneOptionValue = noneOption.value;
        if (selection.length > 0) {
          if (selection[selection.length - 1] === noneOptionValue) {
            this.$set(this.multipleSelectedAnswers, index, [noneOptionValue]);
            this.$set(this.selectedAnswers, index, [noneOption]);
          } else {
            const newSelection = selection.filter((value) => value !== noneOptionValue);
            const selectedOptions = questionOptions.filter((option) => newSelection.includes(option.value));
            this.$set(this.multipleSelectedAnswers, index, newSelection);
            this.$set(this.selectedAnswers, index, selectedOptions);
          }
        } else {
          this.$set(this.multipleSelectedAnswers, index, []);
          this.$set(this.selectedAnswers, index, null);
        }
      } else if (selection.length > 0) {
        const selectedOptions = questionOptions.filter((option) => selection.includes(option.value));
        this.$set(this.multipleSelectedAnswers, index, selection);
        this.$set(this.selectedAnswers, index, selectedOptions);
      } else {
        this.$set(this.multipleSelectedAnswers, index, []);
        this.$set(this.selectedAnswers, index, null);
      }
    },
    isYesNoQuestion(options) {
      if (options && options.length !== undefined) {
        if (options.length !== 2) {
          return false;
        }
        const lowerCaseOptions = options.map((option) => option.option.toLowerCase());
        return lowerCaseOptions.includes('sí') || lowerCaseOptions.includes('si') || lowerCaseOptions.includes('yes');
      }
      return false;
    },
    // Rejected user
    endStep() {
      // If endstep and user accepts update data saved in provisional data
      if (this.dataConsent) {
        this.$emit('updateNotPassedSaveData', {});
      }
      window.location.reload();
    },
    preventDoubleClick(event) {
      event.preventDefault();
    },
    async initializeAnalytics() {
      if (await isSupported()) {
        const app = initializeApp(getFirebaseConfig());
        this.analytics = getAnalytics(app);
        this.analyticsInitialized = true;
      }
    },
  },
};
</script>
<style scoped>
.main-screen {
  margin: 0;
}

.main-container {
  font-size: 1em;
  display: flex;
  flex-direction: column;
}

.questionary-content {
  margin: 0;
  padding: 0;
}

.language-icons {
  height: 7vh;
  margin: 1vh 0;
  padding-left: 0 !important;
  margin-left: 10px !important;
}

.sermes-image-content {
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
  padding: 0;
}

.sermes-image {
  margin: 0;
  padding: 0;
  width: 100%;
  height: auto;
}

.responsive-image {
  height: 100vh;
}

.right-side {
  width: 100%;
  margin: 0 auto;
  padding: 0;
}

.information-content {
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.step-title {
  margin-top: 3vh;
  font-size: 1em;
  height: 5vh;
  font-family: 'Roboto-Regular';
  background: linear-gradient(90deg, #13c5e0, #2e90e0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* scroll only questions */
/* .questions-content {
  margin: auto;
  height: 60vh;
  width: 95%;
  overflow: scroll;
  overflow-x: hidden;
}

.questions-content::-webkit-scrollbar {
  width: 10px;
}

.questions-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.questions-content::-webkit-scrollbar-thumb {
  background: linear-gradient(0deg, #13c5e0, #2e90e0);
  border-radius: 5px;
}

.questions-content::-webkit-scrollbar-thumb:hover {
  background: #555;
} */

.questions-content {
  margin: auto;
  width: 95%;
  margin-left: 0 !important;
}

.form-card {
  margin: 0;
  padding: 0;
  box-shadow: none !important;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.accept-checkbox {
  margin-top: 0 !important;
}

.questions-scrollable {
  margin-right: 3%;
  height: 87vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.questions-scrollable::-webkit-scrollbar {
  width: 12px;
}

.questions-scrollable::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.questions-scrollable::-webkit-scrollbar-thumb {
  background-color: #13c5e0;
  border-radius: 10px;
  border: 3px solid #f1f1f1;
}

.questions-scrollable::-webkit-scrollbar-thumb:hover {
  background-color: #2e90e0;
}

@-moz-document url-prefix() {
  .questions-scrollable {
    scrollbar-width: thin;
    scrollbar-color: #13c5e0 #f1f1f1;
  }
}

.decline-checkbox {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.invalid-radio.v-input--selection-controls .v-radio>>>.v-label {
  color: red !important;
}

.invalid-select {
  border-color: red !important;
  color: red !important;
}

.flag {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.trial-button {
  margin-top: 0vh;
  margin-bottom: 10vh;
  text-align: center;
  font-family: 'Roboto-Bold';
  font-size: 0.9em;
  border-radius: 23px;
  background: none !important;
  border: solid var(--highlightedPU) 3px !important;
  color: var(--highlightedPU) !important;
  opacity: 1;
  box-shadow: none !important;
}

.trial-buttons {
  margin-top: 5vh;
  width: 100%;
}

.button-enabled {
  border: solid var(--highlightedPU) 3px;
  color: var(--highlightedPU);
  opacity: 1;
}

.button-disabled {
  cursor: not-allowed ! important;
  border: solid var(--nonHighlightedTextPU) 3px;
  color: var(--nonHighlightedTextPU);
  opacity: 0.45;
}

#trial-form-previous-button {
  width: 180px;
  height: 40px;
  margin-right: 5%;
  font-family: 'Roboto-Bold';
  font-size: 1em;
  border-radius: 23px;
  background: none !important;
  box-shadow: none !important;
}

#trial-form-next-button {
  width: 170px;
  height: 40px;
  font-family: 'Roboto-Bold';
  font-size: 1em;
  border-radius: 23px;
  background: none !important;
  box-shadow: none !important;
  ;
}

/* Modal Content */
.information-trial {
  z-index: 99;
  text-align: left;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(18, 197, 224, 0.4);
}

.modal-right-side {
  background-color: #fefefe;
  margin: 0 auto;
  margin-top: 9vh;
  border: 1px solid #888;
  width: 70%;
  border-radius: 15px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.7);
}

.modal-logo {
  height: 8vh;
  margin-top: 3vh;
  margin-left: 0;
  padding: 0;
}

.gradient-line {
  margin: auto;
  width: 86%;
  height: 3px;
  background: linear-gradient(90deg, #13c5e0, #2e90e0);
}

.modal-trial-title {
  margin-top: 3vh;
  margin-left: 7%;
  font-family: 'Roboto-Regular';
  font-size: 1.3em;
  color: #00BFFF !important;
}

.modal-trial-text {
  width: 85%;
  height: auto !important;
  margin-top: 3vh;
  margin-bottom: 45px;
  margin-left: 7%;
  opacity: 1;
  font-family: 'Roboto-Regular';
  font-size: 1em;
  background: none !important;
  color: var(--typographyPU) !important;
  text-align: left;
}

.modal-trial-button {
  margin-top: 3vh !important;
  margin-bottom: 5vh;
  text-align: center;
  width: 220px;
  height: 45px !important;
  font-family: 'Roboto-Bold';
  font-size: 0.9em;
  border-radius: 23px;
  background: none !important;
  border: solid var(--highlightedPU) 3px !important;
  color: var(--highlightedPU) !important;
  opacity: 1;
  box-shadow: none !important;
}

.modal-trial-negative-content {
  background-color: #fefefe;
  margin: 0 auto;
  margin-top: 5vh;
  border: 1px solid #888;
  width: 80%;
  border-radius: 15px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.7);
}

.modal-trial-negative-title {
  margin-top: 5vh;
  margin-left: 7%;
  font-family: 'Roboto-Regular';
  font-size: 1.3em;
  color: rgb(255, 14, 14);
}

.modal-trial-negative-text {
  width: 80%;
  height: auto !important;
  margin-top: 3vh;
  margin-left: 7%;
  opacity: 1;
  font-family: 'Roboto-Regular';
  font-size: 1em;
  background: none !important;
  color: var(--typographyPU) !important;
  text-align: left;
}

.modal-checkbox-negative {
  width: 85%;
  height: auto !important;
  margin: 2vh 0;
  margin-left: 7%;
  font-family: 'Roboto-Regular';
  font-size: 1em;
  background: none !important;
  color: var(--typographyPU) !important;
  text-align: left;
}

.modal-trial-negative-thx {
  width: 85%;
  height: auto !important;
  margin-top: 2vh;
  margin-bottom: 3vh;
  margin-left: 7%;
  opacity: 1;
  font-family: 'Roboto-Regular';
  font-size: 1em;
  background: none !important;
  color: var(--typographyPU) !important;
  text-align: left;
}

.modal-trial-negative-button {
  margin-bottom: 3vh;
  text-align: center;
  width: 220px;
  height: 45px !important;
  font-family: 'Roboto-Bold';
  font-size: 0.9em;
  border-radius: 23px;
  background: none !important;
  border: solid var(--highlightedPU) 3px !important;
  color: var(--highlightedPU) !important;
  opacity: 1;
  box-shadow: none !important;
}

.close {
  margin-top: -12px;
  margin-bottom: 0;
  color: var(--typographyPU);
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

/* End Modal */

@media (max-width: 960px) {
  .main-screen {
    padding: 0 5%;
    flex-direction: column;
  }

  .sermes-image-content {
    height: auto;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mobile-image {
    max-height: 10vh;
    max-width: 100%;
    display: block;
    margin: 0 auto;
    margin-top: 0;
  }

  .questions-scrollable {
    margin-right: 3%;
    height: auto;
  }

  .form-buttons {
    padding-bottom: 2vh !important;
    margin-top: 0 !important;
  }

  .trial-buttons {
    margin-top: 0;
    width: 100%;
  }

  #trial-form-previous-button,
  #trial-form-next-button {
    width: 40%;
  }

  .modal-trial-negative-content {
    width: 95%;
    padding: 0 10%;
  }

  .modal-right-side {
    width: 95%;
    padding: 0 10%;
  }

}

@media (min-width: 961px) and (max-width: 1264px) {
  .main-screen {
    flex-direction: row;
  }

  .sermes-image-content {
    height: auto;
  }

  .responsive-image {
    height: auto;
  }

  #trial-form-previous-button,
  #trial-form-next-button {
    width: 200px;
  }

  .questions-scrollable {
    height: 80vh;
  }
}

@media (min-width: 1265px) {
  .main-screen {
    flex-direction: row;
  }

  .sermes-image-content {
    height: 100vh;
  }

  .responsive-image {
    height: 100vh;
  }

  #trial-form-previous-button,
  #trial-form-next-button {
    width: 180px;
  }

  .questions-scrollable {
    height: 87vh;
  }
}
</style>
